import produce from "immer";
import { MediaActions } from "./action";
import { MediaState } from "typings/media";
import { isNullOrUndefined } from "util";

export interface State extends MediaState
{
}

const initialState: State = {
  media: []
};

const reducer = (state = initialState, action: MediaActions): State => produce(state, draft =>
{
    if (action.type === "LOAD_MEDIA_SUCCES")
    {
        const { media } = action;
        media.forEach(element => 
        {
            const index =  draft.media.findIndex(x => x.id === element.id);
            if (index > -1)
            {
                draft.media[index] = element;
            }
            else
            {
                draft.media.push(element);
            }
        });
    }

    if (action.type === "DELETE_MEDIA_SUCCESS")
    {
        const { id } = action;
        draft.media = draft.media.filter(x => x.id !== id && x.parentId !== id);
    }

    if (action.type === "NEW_MEDIA_SUCCESS")
    {
        const { media } = action;
        draft.media = draft.media.concat(media);
    }

    if (action.type === "UPDATE_MEDIA_SUCCESS")
    {
        const { id, data } = action;
        const media = draft.media.find(x => x.id === id);
        if (media)
        {
            for (const fieldName in data)
            {
                media.data[fieldName] = data[fieldName];
            }
        }
      
    }
});

export const getFolderContent = (state: State, parentId?: string) =>
{
    if (isNullOrUndefined(parentId))
    {
        return state.media.filter(item => isNullOrUndefined( item.parentId));
    }
    return state.media.filter(item => item.parentId === parentId);
};

export const getMediaByType = (state: State, type: string) => state.media.filter(item => item.type === type);

export const getMedia = (state: State, id: string) => state.media.find(item => item.id === id);

export const getAllMediaItems = (state: State) => state.media;

export const getMultipleMedia = (state: State, ids: string []) => state.media.filter(item => ids.indexOf(item.id) > -1 );



export default reducer;


// WEBPACK FOOTER //
// ./src/state/media/index.ts